import {h, Component} from 'preact';
import {createPortal} from 'preact/compat';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designService from '../service/designService';
import Renderer from '../canvas/renderer';
import constants from '../constants';
import Spinner from "./Spinner";
import {showDuplicatedDesign} from "../util";

@connect(reduce, actions)
class MakeCopyModal extends Component {
  constructor() {
    super();

    this.state = {
      step: 'one',
      title: 'Save a Copy...',
      name: '',
      newId: '',
      error: ''
    };

    this.onChangeDesignName = (event) => {
      this.setState({name: event.target.value})
      if (event.keyCode === constants.ENTER_KEY) {
        event.preventDefault();
        event.stopPropagation();
        this.makeCopy();
      }
    };

    this.makeCopy = () => {
      if (!this.state.name.trim()) {
        return
      }

      this.props.markAsModified();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      designService.updateDesign({
        id: this.props.designId,
        html: Renderer.getPagesContent()
      }).then(() => {
        designService.makeCopy(this.props.designId, this.state.name, this.props.newSize,
          this.props.cWidth, this.props.cHeight, this.props.cUnit).then(response => {
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);

          this.setState({
            step: 'two',
            title: 'Success!',
            newId: response.data
          })
        }).catch(err => {
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);
          showDuplicatedDesign(this.state.name);
        })
      })
    };

    this.redirect = () => {
      this.props.setShowExitWarning(false);
      location.href = location.protocol + '//' + location.hostname + location.pathname + '?id=' + this.state.newId
    }
  }

  render(props, state) {

    const content = props.isSaving ? <Spinner/> :
      (state.step === 'one' ? (
        <div className="form-block">
          <input type="text" placeholder="Design name..." value={state.name} onKeyUp={this.onChangeDesignName}/>
        </div>
      ) : (
        <p>A copy was created. Click OK to continue.</p>
      ));

    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose}/>
      <div className="modal save-modal">
        <header>
          <h2>{state.title}</h2>
        </header>
        <div className="content">
          {content}
          <p style={{color: '#f9605b', fontSize: '13px'}}>{state.error}</p>
          <footer className={state.step === 'one' ? '' : 'hidden'}>
            <a className="btn decline" onClick={props.onModalClose}>Cancel</a>
            <a className={"btn primary accept " + (state.name.trim() === '' ? 'disabled' : '')} onClick={this.makeCopy}>Save a copy</a>
          </footer>

          <footer className={state.step === 'two' ? '' : 'hidden'}>
            <a className="btn primary" onClick={this.redirect}>Ok</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}

export default MakeCopyModal;
